import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const BrandVoiceListPage = lazyWithRetry(() =>
  import('./pages/BrandVoiceListPage').then((module) => ({ default: module.BrandVoiceListPage }))
)

const BrandVoiceFormPage = lazyWithRetry(() =>
  import('./pages/BrandVoiceFormPage').then((module) => ({ default: module.BrandVoiceFormPage }))
)

const BrandVoiceTemplatePickerPage = lazyWithRetry(() =>
  import('./pages/BrandVoiceTemplatePickerPage').then((module) => ({
    default: module.BrandVoiceTemplatePickerPage,
  }))
)

const routes: AppRoute[] = [
  {
    path: 'brand-voices',
    children: [
      {
        index: true,
        element: BrandVoiceListPage,
        meta: {
          title: 'brandVoice.title',
        },
      },
      {
        path: 'new',
        children: [
          {
            index: true,
            element: BrandVoiceTemplatePickerPage,
            meta: {
              title: 'brandVoice.templates.pageTitle',
            },
          },
          {
            path: 'form',
            element: BrandVoiceFormPage,
            meta: {
              title: 'brandVoice.form.createTitle',
            },
          },
        ],
      },
      {
        path: ':id/edit',
        element: BrandVoiceFormPage,
        meta: {
          title: 'brandVoice.form.editTitle',
        },
      },
    ],
  },
]

export default routes
